import moment from 'moment';
import * as Yup from 'yup';
let validationSchema = Yup.object({
  punch_date: Yup.string('page.punch_in_out_date_required')
    .required('page.punch_in_out_date_required')
    .test('is-date-in-range', 'page.punch_in_out_date_required', function (punchDate) {
      const { previous_punch_timestamp, next_punch_timestamp } = this.parent;

      const dateOnly = moment(punchDate, 'YYYY-MM-DD');
      const prev = moment(previous_punch_timestamp);
      const next = moment(next_punch_timestamp);

      if (!dateOnly.isValid()) {
        return this.createError({
          path: 'punch_date',
          message: 'page.punch_in_out_date_invalid_date'
        });
      }

      // Check if date is same or after previous, and same or before next
      if (dateOnly.isBefore(prev, 'day')) {
        return this.createError({
          path: 'punch_date',
          message: 'page.punch_in_out_date_must_be_after_previous_punch_date'
        });
      }

      if (dateOnly.isAfter(next, 'day')) {
        return this.createError({
          path: 'punch_date',
          message: 'page.punch_in_out_date_must_be_before_next_punch_date'
        });
      }

      return true;
    })
    .typeError('page.punch_in_out_date_required'),

  time: Yup.string('page.punch_in_out_time_required')
    .required('page.punch_in_out_time_required')
    .typeError('page.punch_in_out_time_required')
    .test(
      'datetime-range-check',
      'page.punch_time_must_be_between_your_previous_and_next_timestamp',
      function (time) {
        const { punch_date } = this.parent;
        const previous = moment(this.parent.previous_punch_timestamp).seconds(0).millisecond(0);
        const next = moment(this.parent.next_punch_timestamp).seconds(0).millisecond(0);
        const combined = moment(`${punch_date} ${time}`, 'YYYY-MM-DD hh:mm:ss A')
          .seconds(0)
          .millisecond(0);

        if (!combined.isValid()) {
          return this.createError({ path: 'time', message: 'page.punch_time_invalid_timestamp' });
        }

        if (combined.isBefore(previous)) {
          return this.createError({
            path: 'time',
            message: 'page.punch_time_must_be_after_or_equal_to_previous_timestamp'
          });
        }

        if (combined.isAfter(next)) {
          return this.createError({
            path: 'time',
            message: 'page.punch_time_must_be_before_or_equal_to_previous_timestamp'
          });
        }

        return true;
      }
    ),
  user_notes: Yup.string('page.punch_in_out_time_required').max(
    500,
    'page.punch_in_out_time_max_limit'
  )
});

export { validationSchema };
